export enum ProductInfoErrorCode {
  FriendlyName,
}
